module.exports = __webpack_public_path__ + "media/图1-31动画.bed1951a.mp4";